import type { FC, ReactNode } from 'react'

import { Plane } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useIntro } from '@/components/landing/intro-context'
import { useBooking } from '@/components/landing/booking-provider'

// Floating booking button on phones, like the boarding call it is
const BookPill: FC = (): ReactNode => {
    const { introStarted } = useIntro()
    const { openBooking } = useBooking()

    return (
        <div
            className={cn(
                'fixed inset-x-0 bottom-[max(1.25rem,env(safe-area-inset-bottom))] z-40 flex justify-center transition-all duration-700 md:hidden',
                introStarted ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'
            )}
        >
            <button
                type='button'
                onClick={openBooking}
                className='inline-flex h-12 items-center gap-3 rounded-full bg-champagne pl-6 pr-2 text-[11px] uppercase tracking-[0.22em] text-obsidian shadow-[0_18px_40px_rgba(0,0,0,0.35)]'
            >
                Book a flight
                <span className='flex size-8 items-center justify-center rounded-full bg-obsidian text-champagne'>
                    <Plane className='size-4' />
                </span>
            </button>
        </div>
    )
}

export default BookPill
